import { Controller } from "@hotwired/stimulus";

// Actions for the contact share menu: native share sheet where available,
// plus explicit copy options. Menu open/close is handled by the co-located
// dropdown controller.
export default class extends Controller {
  static targets = ["native"];
  static values = { url: String, title: String, text: String };

  connect() {
    if (!navigator.share) {
      this.nativeTargets.forEach((el) => el.remove());
    }
  }

  async share(event) {
    event.preventDefault();
    this.hideMenu();
    try {
      await navigator.share({
        title: this.titleValue,
        text: this.textValue,
        url: this.urlValue,
      });
    } catch (error) {
      // User dismissed the share sheet — not an error
      if (error.name !== "AbortError") console.warn("Share failed", error);
    }
  }

  copyLink(event) {
    this.copy(event, this.urlValue);
  }

  copyDetails(event) {
    this.copy(event, [this.textValue, this.urlValue].filter(Boolean).join("\n"));
  }

  async copy(event, value) {
    event.preventDefault();
    const item = event.currentTarget;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.setAttribute("readonly", "");
        ta.style.position = "absolute";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      this.flash(item);
    } catch (e) {
      console.warn("Share copy failed", e);
    }
  }

  flash(item) {
    const original = item.innerHTML;
    item.textContent = "Copied!";
    setTimeout(() => {
      item.innerHTML = original;
      this.hideMenu();
    }, 900);
  }

  hideMenu() {
    this.application
      .getControllerForElementAndIdentifier(this.element, "dropdown")
      ?.hide();
  }
}
